import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppWhoQuestionnairePage } from './app-who-questionnaire';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppWhoQuestionnairePage,
  ],
  imports: [
    IonicPageModule.forChild(AppWhoQuestionnairePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppWhoQuestionnairePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-who-questionnaire/app-who-questionnaire.module.ts